import React from 'react';
import ListItem from 'components/ListItem';
import { SprayWaterSourceId } from 'services/sprayEvents/types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { WaterSourceName } from 'services/waterSource/types';
import { makeSelectWaterSourceName } from './selectors';

export interface OwnProps {
    waterSourceId: SprayWaterSourceId;
}

export interface ConnectedProps {
    waterSourceName: WaterSourceName;
}

type Props = OwnProps & ConnectedProps;

export class SummaryApplicationWaterSourceListItemComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { waterSourceName } = this.props;

        return (
            <ListItem
                description="Water source"
                value={waterSourceName}


            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    waterSourceName: makeSelectWaterSourceName()
});

export default connect(mapStateToProps)(
    SummaryApplicationWaterSourceListItemComponent
);
